<template>
  <div>
    <div class="card border-0 shadow-sm" style="border-radius: 14px; background: #ffffff; border: 1.5px solid #e2e8f0 !important; box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);">
      <!-- Standard Vertex Header -->
      <div class="card-header bg-white border-0 pt-3 pb-2 px-3 d-flex justify-content-between align-items-start align-items-sm-center flex-wrap gap-2" style="border-bottom: 1px solid #f1f5f9 !important;">
        <div class="d-flex align-items-center gap-2">
          <div class="widget-icon-pill" style="background-color: #f3e8ff; color: #8b5cf6; width: 34px; height: 34px; border-radius: 9px; display: flex; align-items: center; justify-content: center; font-size: 0.95rem; flex-shrink: 0;">
            <i class="fas fa-fish"></i>
          </div>
          <div>
            <h6 class="mb-0 fw-bold" style="color: #1e293b; font-size: 0.875rem;">Click Throughs on Phishing Emails</h6>
            <small class="text-muted" style="color: #64748b; font-size: 0.72rem;">Simulated phishing test engagement metrics</small>
          </div>
        </div>
      </div>

      <div class="card-body p-3">
        <div class="row">
          <div class="col text-center mx-auto" v-if="loading">
            <img src="@/assets/img/loading.svg" class="d-none d-sm-inline mx-auto" alt="">
            <img src="@/assets/img/loading-mobile.svg" class="d-inline d-sm-none mb-3" alt="">
          </div>

          <div id="chart" class="w-100 mx-auto" style="margin-top: 4px; font-size: 14px;" v-else>
            <div v-if="series[0].data.length == 0">
              <p class="p-5 text-center text-muted fs-6">No Data Available</p>
            </div>
            <div v-else>
              <div class="d-flex align-items-center flex-wrap gap-2 mb-2">
                <span for="dateFrom" class="small fw-semibold text-muted">Range: </span>
                <Datepicker id="dateFrom" :enable-time-picker="false"
                  v-model="date" range auto-apply @cleared="handleClear"
                  @update:model-value="handleDate" placeholder="Select date range" input-class-name="date-picker-input"
                  format="yyyy/MM/dd" :max-date="new Date()"/>
              </div>

              <div class="mt-2 w-100">
                <div class="click-through-chart-wrapper w-100" v-if="!noData">
                  <apexchart type="line" height="260" width="100%" class="w-100" :options="chartOptions" :series="series" />
                </div>
                <div class="d-flex justify-content-center align-items-center text-muted w-100" v-else>
                  <p class="p-5 mb-0">No date range selected.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Card Footer with Download Button -->
        <div class="mt-3 pt-3 border-top d-flex align-items-center" style="border-color: #f1f5f9 !important;">
          <button
            :disabled="downloading"
            type="button"
            class="btn-download-pill"
            v-tooltip.top="'Download detailed Phishing Report (.xlsx)'"
            @click="downloadPhishingSummary"
          >
            <div v-if="downloading" class="spinner-border text-primary me-1" role="status" style="height: 12px; width: 12px;">
              <span class="visually-hidden">Loading...</span>
            </div>
            <svg v-if="!downloading" class="download-icon" width="13" height="13" viewBox="0 0 16 16" fill="currentColor">
              <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
              <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
            </svg>
            <span class="download-text">Download</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

 <script>
  import moment from 'moment';
  import * as XLSX from 'xlsx'

  export default {
    name: 'Dashboard',
    props: ['organisationID', 'isManager', 'showProduct'],

     data() {
        return {
          loading: true,
          downloading: false,
          btnDownload: "#00A0C1",
          series: [{
              name: "Click Throughs",
              data: [],
          },
          {
              name: "Emails Sent",
              data: [],
          }
        ],
          chartOptions: {
            chart: {
              fontFamily: 'inherit',
              height: 260,
              width: '100%',
              redrawOnParentResize: true,
              redrawOnWindowResize: true,
              parentHeightOffset: 0,
              type: 'line',
              zoom: {
                enabled: false
              },
              toolbar: {
                show: false
              }
            },
            colors: ['#00A0C1', '#435666'],
            dataLabels: {
              enabled: false
            },
            stroke: {
              curve: 'smooth',
              width: 3
            },
            grid: {
              borderColor: '#f1f5f9',
              strokeDashArray: 4,
              padding: {
                left: 8,
                right: 12,
                top: 4,
                bottom: 0
              }
            },
            xaxis: {
              categories: [],
              labels: {
                style: {
                  colors: '#64748b',
                  fontSize: '11px'
                }
              },
              axisBorder: {
                color: '#e2e8f0'
              }
            },
            yaxis: {
              labels: {
                style: {
                  colors: '#64748b',
                  fontSize: '11px'
                },
                formatter: (value) => {
                  return value.toFixed(1)
                },
              }
            },
            legend: {
              position: 'top',
              horizontalAlign: 'right',
              labels: {
                colors: '#475569'
              }
            }
          },
          range:{
            from:moment().subtract(14, 'days').format('YYYY-MM-DD'),
            to:moment().format('YYYY-MM-DD'),
          },
          date: null,
          clear: false,
          noData: false,
      }
    },

    async created() {
      if (!this.showProduct) return

      this.vssWidth = this.$vssWidth;
      this.date = [this.range.from, this.range.to];
      await this.init()
    },

    methods: {
      async init(){
        this.overdueTrainings = [];
        this.quizResults = [];
        this.loading = true;

        this.getData()
      },

      formatDateLabel(date) {
        return moment(date).format('DD MMM');
      },

      formatInputLabel(date) {
        if (date == null) return;

        return date.map(d => moment(d).format('YYYY/MM/DD')).join(' - ');
      },

      getData() {
        let params = {
          from: this.range.from,
          to: this.range.to,
        };

        if (this.isManager)  params.manager = this.isManager;

        return new Promise((resolve, reject) => {
          this.$axios.get("/orgadmin/organisations/" + this.organisationID + "/phishing/click-through", { params })
            .then(response => {
              if (response.data.success) {

                // map click through data
                let clickCount = response.data.click_count;
                let labels = Object.keys(clickCount).map(date => {
                  return { originalDate: date, formattedDate: this.formatDateLabel(date) };
                });
                let seriesData = Object.values(clickCount);
                this.series[0].data = seriesData;

                // map email sent
                let emailSent = response.data.email_sent;
                let emailSentData = Object.values(emailSent);
                this.series[1].data = emailSentData;

                this.chartOptions = {
                  ...this.chartOptions,
                  xaxis: {
                    ...this.chartOptions.xaxis,
                    categories: labels.map(item => item.formattedDate)
                  }
                };

                this.loading = false;
                resolve();
              }
            })
            .catch(error => {
              reject(error);
            });
        });
      },

      handleDate(){
        if (this.date == null) return;

        if (this.date[1] == null){
          this.$toast.error("Please select a valid date range");
          return;
        }

        //set date ranges
        this.range.from = moment(this.date[0]).format('YYYY-MM-DD');
        this.range.to = moment(this.date[1]).format('YYYY-MM-DD');

        // set loading state
        this.loading = true;
        //get new data
        this.getData();
      },

      async downloadReport() {
      if (!this.$store.state.user.organisation) {return;}

      let params = {
          from: this.range.from,
          to: this.range.to,
        };

      if (this.isManager)  params.manager = this.isManager;

      let data = await this.$axios.get("/orgadmin/organisations/" + this.organisationID + "/phishing/click-through/download", { params })
          .then((response) => {
              return response.data.phishing_report
          })
          .catch();

      return data;

    },

    sanitizeSpreadsheetCell(val) {
      if (typeof val !== 'string') return val ?? ''
      if (/^[=+\-@\t\r]/.test(val)) {
        return `'${val}`
      }
      return val
    },

    async downloadPhishingSummary() {
      this.downloading = true;

      let data = await this.preparePhishingSummary();
      var dateToday = moment().format("YYYYMMDD");


      const ws = XLSX.utils.aoa_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "PhishingSummary");
      /* generate file and send to client */

      XLSX.writeFile(wb, dateToday + "_" + this.formattedOrgName + "_Phishing Report.xlsx");

      this.downloading = false;
      this.btnDownload = '#00A0C1';
    },

    async preparePhishingSummary() {
      let phishingSummaries = await this.downloadReport();
      let rows = [["User", "Email", "Template", "Date Email Sent (UTC)", "Date First Click (UTC)", "Total Clicks", "Action Taken"]];

      for (const phishingSummary of (phishingSummaries || [])) {
        // fix for click links where default is zero
        // considered as 1 click since they have a record on click-logs
        if (phishingSummary["total_clicks"] == 0 && phishingSummary["action_taken"] != "No Action")
          phishingSummary["total_clicks"]++

          rows.push([
            this.sanitizeSpreadsheetCell(phishingSummary["user_name"]),
            this.sanitizeSpreadsheetCell(phishingSummary["email"]),
            this.sanitizeSpreadsheetCell(phishingSummary["template"]),
            phishingSummary["date_email_sent"] && phishingSummary["date_email_sent"] !== "0001-01-01T00:00:00Z" ? moment.utc(phishingSummary["date_email_sent"]).format("DD/MM/yyyy") : null,
            phishingSummary["action_taken"] === "No Action" ? null : (phishingSummary["date_first_clicked"] && phishingSummary["date_first_clicked"] !== "0001-01-01T00:00:00Z" ? moment.utc(phishingSummary["date_first_clicked"]).format("DD/MM/yyyy h:mm a") : null),
            phishingSummary["total_clicks"],
            this.sanitizeSpreadsheetCell(phishingSummary["action_taken"]),
          ]);
      }
      return rows;
    },

      handleClear() {
        this.range = { ...this.defaultRange };
        // this.loading = true;
        // this.getData();
      }
  },

  computed: {
    orgName(){
      return this.$store.state.auth.isSuperAdmin || this.$helper.isVertexAnalyst() ? this.$store.state.user.organisation.name : this.$store.state.user.organisation.organisation
    },

    formattedOrgName() {
      if (this.orgName) {
        if (this.orgName.includes(" ")) {
          // If orgName contains spaces, replace them with underscores
          return this.orgName.replace(/ /g, "_");
        } else {
          // If orgName doesn't contain spaces, keep it as is
          return this.orgName;
        }
      }
      return "";
    },

    defaultRange() {
      return {
        from: null,
        to: null,
      };
    },

  },

  watch: {
    range: {
      handler(newValue) {
        // Check if the range is null or has null values
        if (newValue.from === null || newValue.to === null) {
          this.noData = true;
        } else {
          this.noData = false;
        }
      },
      deep: true, // Deep watch to react to changes within the range object
    },
  },

  }

 </script>
 <style scoped>
.click-through-chart-wrapper {
  width: 100%;
  min-height: 260px;
}

.click-through-chart-wrapper :deep(.vue-apexcharts),
.click-through-chart-wrapper :deep(.apexcharts-canvas) {
  width: 100% !important;
}

.widget-icon-pill {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.btn-download-pill {
  background-color: #ffffff;
  color: #00a0c1;
  border: 1.5px solid #00a0c1;
  border-radius: 20px;
  padding: 4px 14px;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.2;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}

.btn-download-pill:hover:not(:disabled) {
  background-color: #00a0c1;
  color: #ffffff;
  border-color: #00a0c1;
  box-shadow: 0 2px 6px rgba(0, 160, 193, 0.35);
}

.btn-download-pill:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-download-pill .download-icon {
  margin-right: 6px;
  flex-shrink: 0;
}

.btn-download-pill .download-text {
  font-weight: 700;
  font-size: 13px;
}
</style>
